import React from 'react';
import { Link } from 'react-router-dom';
// Default Link component
const SimpleLink = ({ children, to, ...props }) => {
    return (React.createElement("a", { href: to, ...props }, children));
};
const isListed = (item, list) => list !== undefined &&
    Boolean(list.find((listItem) => {
        let url = listItem.split('?')[0]; // remove params for the match
        url = url.length > 1 ? url.replace(/\/$/, '') : url; // ignore trailing slash
        const pattern = `^${url.replace('/', '\\/')}(\\/.*)?(\\?.*)?$`;
        return new RegExp(pattern, 'i').test(item);
    }));
const getHooks = (useFrameHooks) => {
    const useLinkComponent = (url) => {
        const { useFrameContext } = useFrameHooks();
        const { internalPaths } = useFrameContext();
        if (typeof url === 'string') {
            return isListed(url, internalPaths) ? Link : SimpleLink;
        }
        else {
            return url ? Link : SimpleLink;
        }
    };
    return { useLinkComponent };
};
export const reactLinkModule = {
    name: 'reactLinkModule',
    getHooks,
};
//# sourceMappingURL=react-link.js.map